
export const roundTo = (value, scale) => {
    scale = (!scale ? 2 : scale);

    if(value > 0)
        return value.toFixed(scale);
    else if (value === 0)
        return "0.00";
    return value;
}